<app-card-collapse title="Fotos Adicionais" cardBodyClass="p-0">

    <div class="d-flex align-items-center p-3 bg-light">
        <div class="px-2 fw-500 flex-grow-1">
            <input [formControl]="form.controls.label" placeholder="Insira aqui uma descrição para a imagem" type="text"
                   class="form-control">
        </div>
        <app-input-img-laudo [url]="form.controls.image.value" [showLinkBtn]="false"
                            (deleteEvent)="form.controls.image.patchValue($event)"
                            (saveEvent)="form.controls.image.patchValue($event)"
                            (editEvent)="form.controls.image.patchValue($event)"></app-input-img-laudo>
        <button (click)="sendForm()"  class="ml-3 btn btn-icon btn-success">
            <span>Adicionar</span><i class="mdi mdi-plus"></i>
        </button>
    </div>

    <div class="row">

        <div *ngFor="let f of listaFotos; let i = index" class="col-12 col-md-6 py-2 px-2 px-lg-2">
            <div class="card bg-light border-0">
                <div class="card-body d-flex align-items-center p-2">
                    <div class="px-2 fw-500 flex-grow-1">
                        <input (blur)="updateLabel(f)" [formControl]="f.label" placeholder="Descrição"
                               type="text" class="form-control">
                    </div>
                    <app-input-img-laudo [url]="f.image.value" [required]="f.required" [loading]="f.loading"
                                         (deleteEvent)="removeFotoAdicional(f)"
                                         (editEvent)="updateFotoAdicional(f, $event)"
                                         (saveEvent)="updateFotoAdiconal(f, $event)">
                    </app-input-img-laudo>
                </div>
            </div>
        </div>

    </div>

</app-card-collapse>